import Helpers from '../helpers/util';

class AdministeredToPatientYesno {
	constructor(el) {
		this.el = el;
		this.submissionId = el.getAttribute('data-submission-id');
		this.buttons = el.querySelectorAll('[data-value]');
		this.errorEl = document.querySelector(
			'.administered-to-patient-yesno__error'
		);
		this.attachHandlers();

		this.isLocal = window.location.hostname === 'localhost';
		this.endpoint = this.isLocal
			? 'https://vaxiplace2016.schweb.net.au/api/coldchain'
			: '/api/coldchain';
		this.tokenEndpoint = this.isLocal
			? 'https://vaxiplace2016.schweb.net.au/session/token'
			: '/session/token';
	}

	attachHandlers = () => {
		this.buttons.forEach(button => {
			const value = button.getAttribute('data-value') === 'true';
			button.addEventListener('click', () => {
				this.handleButtonClick(value);
			});
		});
	};

	fetchCSRFToken = () => {
		return fetch(this.tokenEndpoint)
			.then(res => res.text())
			.catch(this.handleError);
	};

	handleButtonClick = async value => {
		this.startLoading();
		const body = {
			submission_id: this.submissionId,
			value
		};
		try {
			fetch(this.endpoint, {
				method: 'POST',
				body: JSON.stringify(body),
				headers: {
					'Content-Type': 'application/json',
					'X-CSRF-Token': await this.fetchCSRFToken()
				}
			})
				.then(this.handleSuccess)
				.catch(this.handleError);
		} catch (error) {
			this.handleError();
		}
	};

	startLoading = () => {
		this.el.style.opacity = 0.5;
		this.el.style.pointerEvents = 'none';
	};

	stopLoading = () => {
		this.el.style.opacity = null;
		this.el.style.pointerEvents = null;
	};

	handleError = () => {
		this.errorEl.innerHTML = 'An error occurred';
		this.stopLoading();
	};

	handleSuccess = () => {
		this.stopLoading();
		this.closeLightbox();
	};

	closeLightbox = () => {
		Helpers.pubsub.publish('close-lightbox');
	};
}

const els = Array.from(
	document.querySelectorAll('.administered-to-patient-yesno')
);
els.forEach(el => {
	new AdministeredToPatientYesno(el);
});
